module.exports = __webpack_public_path__ + "img/success.3b78562d.svg";